import React, { RefObject, useRef } from "react";
import { CSSTransition } from "react-transition-group";

/**
 * Specification of the fade duration given in milliseconds.
 */
const DURATION = 125;

/**
 * Simple css transition that'll crossfade between institution throbber and the
 * actual institution name..
 */
// tslint:disable-next-line variable-name
export const UserInstitutionFade: React.FC<{
  children: (ref: RefObject<any>) => React.ReactNode;
}> = (props) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <CSSTransition
      {...props}
      timeout={DURATION}
      classNames="userInstitutionFade"
      nodeRef={ref}
    >
      <>
        {props.children(ref)}

        <style jsx global>{`
          .userInstitutionFade-enter {
            opacity: 0.001;
          }

          .userInstitutionFade-enter-active {
            opacity: 1;

            /** Apply transition */
            transition: opacity ${DURATION}ms linear;
          }

          .userInstitutionFade-exit {
            /** Pull exiting items out of render stack  */
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;

            /** Prepare fade out */
            opacity: 1;
          }

          .userInstitutionFade-exit-active {
            opacity: 0.001;

            /** Apply transition */
            transition: opacity ${DURATION}ms linear;
          }
        `}</style>
      </>
    </CSSTransition>
  );
};
